// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"de801386","455":"182820ea","977":"f08ec78a"}[chunkId] + ".chunk.js";
};